export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc'
} as const

export const COLUMN_CELL_TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  COMPONENT: 'component'
} as const

export const BASE_TABLE_TEST_IDS = {
  pagination: 'base-table-test-id',
  tableHead: 'table-head',
  selectAllCheckbox: 'select-all-checkbox',
  tableHeadCell: 'table-head-cell',
  tableSortLabel: 'table-sort-label',
  columnVisibilityButton: 'column-visibility-button',
  row: 'table-row',
  detailsRow: 'table-details-row',
  expandMoreIcon: 'table-expand-icon',
  collapseIcon: 'table-collapce-icon',
  rowActions: 'table-row-actions-cell'
}
